<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    // 单点登录返回方法
    async getUrl() {
      this.$router.replace({
        path: "/",
      });
    },
  },
  mounted() {
    this.getUrl();
  },
};
// test_shi Datahome123
</script>
